import { render, staticRenderFns } from "./FeedRequestModal.vue?vue&type=template&id=038f214c&"
import script from "./FeedRequestModal.vue?vue&type=script&lang=js&"
export * from "./FeedRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports